import { StyleInputType } from '../inputType';

export const itemStylesDefinitions = {
  itemSpacing: StyleInputType.SPACING,
} satisfies Record<string, StyleInputType>;
